import styled from "styled-components";

import { colorsPalettes, rgba, setFont } from "@similarweb/styles";

import { ProgressBar } from "app/components/React/ProgressBar/ProgressBar";
import { percentageFilter } from "app/filters/ngFilters";
import { Text } from "app/pages/keyword-analysis/TotalTrafficPage/StyledComponents";

const NA = "N/A";

const ProgressBarWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: end;
`;

const ProgressContainer = styled(Text)`
    width: 100%;
    ${setFont({ $size: 13, $color: rgba(colorsPalettes.carbon[500], 0.8) })};
`;

const TextValue = styled.span`
    display: inline-block;
    min-width: 36px;
`;

interface Props {
    value?: number | null;
    fraction?: number;
}

export const ProgressBarPercentCell = ({ value, fraction = 0 }: Props) => {
    const width = value ? value * 100 : 0;
    const valuePercents = value ? percentageFilter()(value || 0, fraction) + "%" : NA;
    return (
        <ProgressBarWrapper>
            <ProgressContainer>
                <div className="swTable-progressBar">
                    <TextValue>{valuePercents}</TextValue>
                    <div className="u-full-width">{valuePercents !== NA ? <ProgressBar width={width} /> : null}</div>
                </div>
            </ProgressContainer>
        </ProgressBarWrapper>
    );
};
